/*
 * @Author: your name
 * @Date: 2020-03-02 21:52:48
 * @LastEditTime: 2020-03-06 22:20:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kkcloud-kk-agentapp-download\siteConfig.js
 */
const EVIROMENT = process.env.EVIROMENT;

function getCommandParams() {
  // CLI参数从第三个开始获取
  const args = process.argv.slice(2);
  const result = {};
  const REG = /^--([^-]+)/;
  for (let i = 0; i < args.length; i++) {
    const match = REG.exec(args[i]);
    // 判断当前参数是否--开头，如果--开头才算合法参数
    if (match) {
      const key = match[1];
      // 如果下个参数也是--开头，本参数则值为空
      if (REG.test(args[i + 1])) {
        // 下一个参数
        result[key] = '';
      } else {
        // 直接跳过下一个参数
        i++;
        result[key] = args[i] || '';
      }
    }
  }
  return result;
}

//站点id

let SITE_ID = getCommandParams().site || getCommandParams().SITE_ID;
const config = {
  '1': {
    key: 'kok',
    title: 'KOK',
    themeColor: '#538DF3',
    appkey: EVIROMENT === 'production' ? 'tjvgkr' : 'tblccn',
    tfAppKey: EVIROMENT === 'production' ? '' : ''
  },
  '2': {
    key: 'yabo',
    title: '亚博包网',
    themeColor: '#3E92FF',
    appkey: EVIROMENT === 'production' ? 't6c15e' : 'tixy53',
    tfAppKey: EVIROMENT === 'production' ? 'r9NwKUj6SC' : 'r9NwKUj6SC'
  },
  '3': {
    key: 'ob',
    title: '欧宝',
    themeColor: '#597EF7',
    appkey: EVIROMENT === 'production' ? 'tla2c7' : 'tsusab'
    // tfAppKey: EVIROMENT === 'production' ? 'YlFrnLpcsU' : 'YlFrnLpcsU'
  },
  '4': {
    key: 'huohu',
    title: '火狐',
    themeColor: '#FF5F53',
    appkey: EVIROMENT === 'production' ? 'tsljlg' : 'td3edf'
    // tfAppKey: EVIROMENT === 'production' ? 'AcmQUbS2Dm' : 'AcmQUbS2Dm'
  },
  '5': {
    key: 'kok',
    title: 'KOK',
    themeColor: '#538DF3',
    appkey: EVIROMENT === 'production' ? 'td7gkc' : 'tblccn'
    // tfAppKey: EVIROMENT === 'production' ? 'LH7CTf3zJG' : 'LH7CTf3zJG'
  },
  '6': {
    key: 'yibo',
    title: '亿博',
    themeColor: '#158BF4',
    appkey: EVIROMENT === 'production' ? 'tbxa3v' : 'tdos2z'
    // tfAppKey: EVIROMENT === 'production' ? 'UYq0efnfml' : 'UYq0efnfml',
  },
  '7': {
    key: 'aoa',
    title: 'AOA',
    themeColor: '#FA541C',
    appkey: EVIROMENT === 'production' ? 't2dc4a' : 'tfl91l'
    // tfAppKey: EVIROMENT === 'production' ? 'Huv3wm5NyW' : 'Huv3wm5NyW'
  },
  '8': {
    key: 'hqbet',
    title: '环球体育',
    themeColor: '#158BF4',
    appkey: EVIROMENT === 'production' ? 't30yfy' : 't658c0'
    // tfAppKey: EVIROMENT === 'production' ? 'OR2VG1Qemf' : 'OR2VG1Qemf'
  },
  '10': {
    key: 'fhty',
    title: '凤凰体育',
    themeColor: '#DBBF7A',
    appkey: EVIROMENT === 'production' ? 't9pzcn' : 'tjg9h0'
    // tfAppKey: EVIROMENT === 'production' ? 'P9RQLpeNna' : 'P9RQLpeNna'
  },
  '11': {
    key: 'qs',
    title: '球速体育',
    themeColor: '#3E92FF',
    appkey: EVIROMENT === 'production' ? 't2ac4h' : 'tzbltu',
    tfAppKey: EVIROMENT === 'production' ? 'WpwMMGyTrB' : 'WpwMMGyTrB'
  },
  '1001': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't6vfvg' : 't6vfvg',
    tfAppKey: EVIROMENT === 'production' ? 'cyGD4yb2cE' : 'cyGD4yb2cE'
  },
  '1002': {
    key: 'qxw',
    title: '球信网',
    themeColor: '#4080ff',
    appkey: EVIROMENT === 'production' ? 'tilgi4' : 'tdudke',
    tfAppKey: EVIROMENT === 'production' ? 'FiNiSG3x4y' : 'FiNiSG3x4y'
  },
  '2001': {
    key: 'leyu',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tnh7bf' : 't8gk7l',
    tfAppKey: EVIROMENT === 'production' ? '5OwFLxgdU3' : '5OwFLxgdU3'
  },
  '3001': {
    key: 'hutihui',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tl976i' : 't3n2o3',
    tfAppKey: EVIROMENT === 'production' ? 'ONaytT12J7' : 'ONaytT12J7'
  },
  '4001': {
    key: 'yaboty',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tflvly' : 'tflvly',
    tfAppKey: EVIROMENT === 'production' ? 'uXjIoPAAys' : 'uXjIoPAAys'
  },
  '5200': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't389bm' : 'tq3mwz'
  },
  '5201': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't3mi3a' : 't092tv'
  },
  '5202': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tv1x9r' : 'toccs3'
  },
  '5203': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't7q7t9' : 'td7ya2'
  },
  '5204': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tpu388' : 't39vc9'
  },
  '5205': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'ts4k2x' : 'tv4ruy'
  },
  '5206': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'takxtf' : 't47h39'
  },
  '5207': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tjpwti' : 'tgqmwg'
  },
  '5208': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tqityx' : 't5et2g'
  },
  '5209': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't8i9u4' : 'tijfrq'
  },
  '5210': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tqgv7i' : 'tmvu1t'
  },
  '5211': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tklgrr' : 'ts95dh'
  },
  '5212': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't6u9pt' : 'tfxgny'
  },
  '5213': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tvy9bp' : 'txanhr'
  },
  '5214': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'twc05v' : 'twzgi8'
  },
  '5215': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tkanv3' : 'tsgb7q'
  },
  '5216': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't64scu' : 'tdoxr2'
  },
  '5217': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'toues4' : 't4mqxf'
  },
  '5218': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tijw3t' : 'tjfgt3'
  },
  '5219': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tiqoz9' : 't9okla'
  },
  '5220': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't64pec' : 'tndkqt'
  },
  '5221': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't83icn' : 't2hcxz'
  },
  '5222': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't4kzzr' : 'tk3lh8'
  },
  '5223': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'ts5nq7' : 'tcbzwf'
  },
  '5224': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'thd7s6' : 'tjzqpu'
  },
  '5225': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tl7jfs' : 'to63ii'
  },
  '5226': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't5ess5' : 'tfb4uy'
  },
  '5227': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't5s3sg' : 'teqq74'
  },
  '5228': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't726yn' : 'tdw239'
  },
  '5229': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tpdl5o' : 'tmahfa'
  },
  '5230': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tfbva4' : 'tvi0ol'
  },
  '5231': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tx7yaa' : 'tmj9hm'
  },
  '5232': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'td9ave' : 'tkddu6'
  },
  // '5000': {
  //   key: 'logobak',
  //   title: '请用系统浏览器打开进行下载',
  //   themeColor: '#fff',
  //   appkey: EVIROMENT === 'production' ? 'tkddu6' : 'tkddu6'
  // },
  '5000': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tbw1hf' : 'tbw1hf'
  },
  '5233': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't6u9pt' : 't6u9pt'
  },
  '5234': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tvo72g' : 'tvo72g'
  },
  '5235': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tmab7l' : 'tmab7l'
  },
  '5236': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't03c80' : 't03c80'
  },
  '5237': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tkb0kd' : 'tkb0kd'
  },
  '5238': {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 't2gocn' : 't2gocn'
  },
  k: {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'tgvdnl' : 'tknmuy'
  },
  s: {
    key: 'logobak',
    title: '请用系统浏览器打开进行下载',
    themeColor: '#fff',
    appkey: EVIROMENT === 'production' ? 'txd190' : 'tqc2jr'
  }
};

module.exports = function(id = SITE_ID) {
  let siteId = id;
  console.log('siteId: ', siteId);
  let result = config[siteId];

  // if (!result) {
  //   result = config['1'];
  //   siteId = 1;
  // }

  return {
    ...result,
    siteId: siteId
  };
};
